import { useMantineTheme } from "@mantine/core";
import React from "react";

import styles from "./user.module.scss";

interface StyledUserProps extends React.HTMLAttributes<HTMLDivElement> {
  isDragging: boolean;
  isSelected: boolean;
  isGhosting: boolean;
}

export const StyledUser = React.forwardRef<HTMLDivElement, StyledUserProps>(
  (
    { isDragging, isSelected, isGhosting, className, style, children, ...rest },
    ref,
  ) => {
    const theme = useMantineTheme();
    return (
      <div
        ref={ref}
        className={`${styles.styledUser} ${className ?? ""}`}
        style={{
          ...style,
          backgroundColor: isDragging
            ? theme.colors.main[5]
            : theme.colors.main[9],
          border: `3px solid ${isSelected ? theme.colors.main[3] : theme.colors.main[9]}`,
          opacity: isGhosting ? 0.8 : 1,
        }}
        {...rest}>
        {children}
      </div>
    );
  },
);
StyledUser.displayName = "StyledUser";

export const StyledUsername: React.FC<
  React.HTMLAttributes<HTMLParagraphElement>
> = ({ children, className, ...rest }) => (
  <p className={`${styles.styledUsername} ${className ?? ""}`} {...rest}>
    {children}
  </p>
);

export const StyledUsersRole: React.FC<
  React.HTMLAttributes<HTMLParagraphElement>
> = ({ children, className, ...rest }) => (
  <p className={`${styles.styledUsersRole} ${className ?? ""}`} {...rest}>
    {children}
  </p>
);

export const StyledSelectionCount: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.styledSelectionCount} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);
